// extracted by mini-css-extract-plugin
export default {"singleClaim":"styles_singleClaim__s0sQv","claimTitle":"styles_claimTitle__CsPx4"};